import { render } from "./AppIcon.vue?vue&type=template&id=2cb8509e"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"
script.render = render

export default script